import { render, staticRenderFns } from "./EmolumentosListagem.vue?vue&type=template&id=b1a165b2&scoped=true&"
import script from "./EmolumentosListagem.vue?vue&type=script&lang=js&"
export * from "./EmolumentosListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a165b2",
  null
  
)

export default component.exports